export default {
  newDesign: true,
  title: "Çocuklar için Matematik Dersleri | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrQMRf",
    segment: 12,
  },
  startPage: {
    title:
      "Çocuklar için Matematik dersleri.<br>ÜCRETSİZ deneme dersi alın.",
    subtitle:
      "<img src=\"https://static.tildacdn.com/tild6337-3962-4830-b438-343836346435/Polygon_296_1.png\" style=\"width: 12px; height: 12px;\"> 5–11 yaş arası çocuklar için uluslararası eğitim standartlarına dayalı, oyun tabanlı bir eğitim formatı<br><img src=\"https://static.tildacdn.com/tild3962-3433-4166-a136-313030396531/Group_1261156251.png\" style=\"width: 12px; height: 12px;\"> Alanında uzman eğitmenler, matematiği heyecan verici ve anlaşılır bir şekilde öğretecek",
    image: {
      url: "/welcome/tr_math_review.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/tr_math_review.png",
      style: {
        width: "100%",
      },
    },
    button: "Ücretsiz deneme dersi alın",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğun matematik, mantık veya aritmetik öğrenme deneyimi var mı?",
      subtitle: "Kadın öğretmen: Çocuğunuza matematiği nasıl öğreteceğinizi öğrenin",
      answers: [
        "🏫 Evet, okulda eğitim aldı",
        "🧒 Evet, kendi başına veya ebeveynlerle eğitim aldı",
         "👩‍🎓 Evet, kurslarda/çocuk branşlarında eğitim aldı",
         "😊 Hayır, deneyimi yok",
      ],
    },
    2: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/tr_math_review_skills.png",
      title: "Biz kimiz?",
      subtitle: "Kodland, 5-17 yaş arası öğrencilerin hayallerini gerçek projeler tasarlayarak hayata geçirdiği, dijital becerilere yönelik çevrimiçi bir eğitim platformudur.",
      button: "Harika!",
    },
    3: {
      question: "Çocuğunuz daha önce online ders aldı mı?",
      answers: [
        "✅ Evet, düzenli aldı",
        "🙂 Evet, kısa süreli aldı",
        "😌 Hayır, hiç almadı",
      ],
    },
    4: {
      question: "Çocuğunuzun eğitimi için aylık hangi bütçe uygundur?",
      financial: true,
      answers: [
        "💵 ₺1.000’e kadar",
        "💳 ₺1.000–2.000",
        "💰 ₺2.000–3.500",
        "🤑 ₺3.500 üzeri",
      ],
    },
    5: {
      question: "Çocuğunuzun ders dışı aktivitelerine aylık ne kadar harcıyordunuz?",
      answers: [
        "🚫 Harcama yapmadım",
        "💵 ₺500–1.500",
        "💳 ₺1.500–3.000",
        "💰 ₺3.000’den fazla"
      ],
    },
    6: {
      question: "Çocuğunuza deneme matematik dersi önerirseniz nasıl tepki verir?",
      answers: [
        "🤩 İlgi gösterir",
        "🤔 Kararsız ama dener",
        "⚽ Başka aktiviteleri tercih eder",
        "❌ İstemediğini söyler"
      ]
    },
    7: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    8: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/tr_fwd_review_5.png",
      title: "Kodland ile daha hızlı öğren",
      subtitle: "Etkileşimli dersler ve bire bir mentor desteği sayesinde konuları daha hızlı anlar ve çok daha uzun süre hatırlarsın.",
      button: "Başla",
    },
    9: {
      title: "Son bir adım kaldı 🎉",
      typeInfo: "congrats",
      subtitle:
        "Çocuğunuzun mantıksal düşünme becerisini ve matematikte özgüvenini geliştirmesine yardımcı olun!",
      button: "Hadi başlayalım!",
    },
    10: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    11: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    12: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    13: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    14: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};